import React from 'react';
import { XCircle } from 'lucide-react';
import { Button } from '../ui/Button';
export const Pains = () => {
  const pains = ['Llegás al club sin saber exactamente qué ejercicios vas a dar hoy', 'Tus alumnos no progresan porque no hay un orden claro de contenidos de clase a clase', 'Tenés grupos con niveles mezclados y no sabés cómo manejarlos sin perder a nadie', 'Cuando hay feriado o un alumno falta, perdés la continuidad técnica de todo el grupo', 'No podés justificar un aumento de cuota porque no tenés nada sistematizado para mostrar', 'Los padres te preguntan "¿cuándo aprende el Axel?" y no tenés una respuesta concreta', 'Llegas a casa agotado/a después de inventar la clase en el camino al club todos los días', 'Sentís que tu trabajo vale mucho más de lo que te pagan pero no sabés cómo demostrarlo'];
  return <section className="py-20 bg-white" data-id="element-182">
      <div className="max-w-4xl mx-auto px-4" data-id="element-183">
        <h2 className="text-3xl md:text-4xl font-bold text-center mb-12 text-gray-900" data-id="element-184">
          Si sos profe de patín artístico, esto te va a sonar conocido:
        </h2>

        <div className="space-y-4 mb-16" data-id="element-185">
          {pains.map((pain, index) => <div key={index} className="flex items-start gap-4 p-4 rounded-xl hover:bg-gray-50 transition-colors" data-id="element-186">
              <XCircle className="w-6 h-6 text-red-500 shrink-0 mt-0.5" data-id="element-187" />
              <p className="text-lg text-gray-700 font-medium" data-id="element-188">❌ {pain}</p>
            </div>)}
        </div>

        <div className="text-center bg-brand-50 rounded-3xl p-10 border border-brand-100" data-id="element-189">
          <h3 className="text-2xl md:text-3xl font-bold text-brand-900 mb-8" data-id="element-190">
            "¿Cuántas clases más vas a improvisar?"
          </h3>
          <Button href="#precios" size="lg" className="w-full sm:w-auto" data-id="element-191">
            👉 BASTA DE IMPROVISAR — QUIERO MI PATÍN 360
          </Button>
        </div>
      </div>
    </section>;
};